export default __webpack_public_path__ + "static/media/golang-icon.ccb52649.svg";